// extracted by mini-css-extract-plugin
export default {"body":"MainLayout_body__7RAr+","renderArea":"MainLayout_renderArea__UzlYZ","renderAreaLanding":"MainLayout_renderAreaLanding__gU0le"};